/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-09-21 15:57:15
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-11-10 10:14:22
 * @FilePath: \frontend-user\src\store\modules\cart.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// Deep copy a copy of data
// 深度 copy 一份数据
const cloneDeep = (data) => {
  return JSON.parse(JSON.stringify(data))
}

const initCartState = {
  includeAlcohol: false
}

const module_ = {
  state: cloneDeep(initCartState),
  mutations: {
    // Initialize state
    // 初始化 state
    resetCartState(state) {
      for (var i in initCartState) {
        state[i] = initCartState[i]
      }
    },
    // Keep the results of checking the alcohol contained
    // 保存检查含有酒精的结果
    checkIncludeAlcohol(state, res) {
      state.includeAlcohol = res
    },
  },
  actions: {},
  getters: {}
}

export default module_